var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlindsRaised(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 159.922L0 223.891H96V159.922H16ZM512 47.977V15.992C512 7.122 504.875 0 496 0H16C7.125 0 0 7.122 0 15.992V47.977C0 56.847 7.125 63.969 16 63.969L0 127.938H96V63.969H128V127.938H512L496 63.969C504.875 63.969 512 56.847 512 47.977ZM496 159.922H128V223.891H512L496 159.922ZM96 223.891V418.796C73.999 426.542 60.75 449.031 64.75 472.02C68.625 495.133 88.625 512 112 512S155.375 495.133 159.25 472.02C163.25 449.031 149.999 426.542 128 418.796V223.891H96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlindsRaised);
export default __webpack_public_path__ + "static/media/blinds-raised.6c2e68315469abeb26ed14022a4d28f4.svg";
export { ForwardRef as ReactComponent };